import React, { useState } from "react";

export default function TextForm(props) {
  const [text, setText] = useState("");
  const [backspaceCount, setBackspaceCount] = useState(0); // State to track backspace count



  // Clear Text
  const handleClearClick = () => {
    let newText = "";
    setText(newText);
    setBackspaceCount(0);
  };
  // Copy to clipboard
const handleCopyClick = () => {
    if (navigator.clipboard && window.isSecureContext) {
        // Use the modern clipboard API
        navigator.clipboard.writeText(text).then(function(){
            window.alert("Copied to clipboard!");
        }).catch(function() {
            window.alert("Failed to copy text to clipboard");
        });
    } else {
        // Fallback for older browsers or insecure context
        let textArea = document.createElement("textarea");
        textArea.value = text;
        // Avoid scrolling to bottom
        textArea.style.position = "fixed";
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.width = "2em";
        textArea.style.height = "2em";
        textArea.style.padding = "0";
        textArea.style.border = "none";
        textArea.style.outline = "none";
        textArea.style.boxShadow = "none";
        textArea.style.background = "transparent";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            window.alert("Suceess");
        } catch (err) {
            window.alert("Failed to copy text to clipboard");
        }

        document.body.removeChild(textArea);
    }
}

  // Handle Key Down
  const handleKeyDown = (event) => {
    if (event.key === "Backspace") {
      event.preventDefault(); // Block the default action of backspace
      setBackspaceCount((prevCount) => prevCount + 1); // Increment backspace counter
    }
  };

  // OnChange in TextArea
  const handleChange = (event) => {
    setText(event.target.value);
  };

  return (
    <>
      <div
        className="container my-5"
        style={{ color: props.mode === "dark" ? "white" : "black" }}
      >
        <h1>{props.heading}</h1>
        <div className="mb-3">
          <textarea
            className="form-control"
            placeholder="Enter your text here..."
            style={{
              backgroundColor: props.mode === "dark" ? "white" : "#042743",
              color: props.mode === "dark" ? "black" : "white",
            }}
            onChange={handleChange}
            value={text}
            id="myBox"
            rows="12"
            spellCheck="false" // Disable spell check
            onKeyDown={handleKeyDown} // Handle key down events to block backspace
          ></textarea>
        </div>
        
        <button
          disabled={text.length === 0}
          className="btn btn-primary mx-1 my-2"
          onClick={handleCopyClick}
        >
          Copy to Clipboard
        </button>
        <button
          disabled={text.length === 0}
          className="btn btn-danger mx-1 my-2"
          onClick={handleClearClick}
        >
          Reset
        </button>
      </div>

      <div
        className="container my-4 mx-1"
        style={{ color: props.mode === "dark" ? "white" : "black" }}
      >
        <h1>Text Summary</h1>
        <p>
          Number of words:{" "}
          {text.split(" ").filter((item) => item !== "").length}{" "}
        </p>
        <p>Number of characters: {text.length}</p>
        <h2>Backspace Count</h2>
        <p>Backspace was pressed: {backspaceCount} times</p>
      </div>
    </>
  );
}
